import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-franchisor-list',
    imports: [RouterLink, NgIf],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-building me-2"></i>Franchisegeber <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <div class="mb-3 d-flex flex-wrap justify-content-between gap-2">
                    <div class="d-flex flex-wrap gap-2">
                        <button type="button" class="btn btn-primary" [routerLink]="['/franchisor', 0]">Franchisegeber anlegen</button>
                    </div>
                    <div class="d-flex flex-wrap gap-2">
                        <button type="button" class="btn btn-outline-secondary" (click)="exportCSV()"><i class="fa-solid fa-file-csv me-1"></i>CSV exportieren</button>
                    </div>
                </div>

                <div class="table-responsive">
                    <table *ngIf="entries?.length > 0" class="table table-striped table-hover mb-0 pointer">
                        <thead>
                        <tr>
                            <th (click)="setOrder('name')">
                                Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('country')">
                                Land <i class="fa-solid" *ngIf="predicate == 'country'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('zip')">
                                PLZ <i class="fa-solid" *ngIf="predicate == 'zip'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('city')">
                                Ort <i class="fa-solid" *ngIf="predicate == 'city'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('street')">
                                Straße <i class="fa-solid" *ngIf="predicate == 'street'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('franchisees')">
                                # Franchisenehmer <i class="fa-solid" *ngIf="predicate == 'franchisees'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('stores')">
                                # Stores <i class="fa-solid" *ngIf="predicate == 'stores'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        @for (entry of entries; track entry.id) {
                            <tr [routerLink]="['/franchisor', entry.id]">
                                <td>{{ entry.name }}</td>
                                <td>{{ entry.country }}</td>
                                <td>{{ entry.zip }}</td>
                                <td>{{ entry.city }}</td>
                                <td>{{ entry.street }}</td>
                                <td>{{ entry.franchisees }}</td>
                                <td>{{ entry.stores }}</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})
export class FranchisorListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'name';
    search: any = {
        text: ''
    };
    reverse = false;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: any): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Franchisor/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.franchisors;
        });
    }

    exportCSV(): void {
        this.dataService.request('Franchisor/exportCSV').subscribe(response => {
            if (response && response.file) {
                this.dataService.generateBlob(response);
            }
        });
    }

}


